// Module
var code = "<a data-bind=\"click: Click\" class=\"tab-link\"> <span data-bind=\"text: Title\"></span> </a>";
// Exports
export default code;